import mod from "-!./UserForm.js?vue&type=script&lang=js&"; export default mod; export * from "-!./UserForm.js?vue&type=script&lang=js&"